<template>
  <ion-item @click="openSelectModal()" lines="inset" class="ion-activatable ripple-parent">
    <mdicon size="24px" slot="start" name="view-module-outline" class="text-medium"></mdicon>
    <ion-input :readonly="true" placeholder="Installatie of component"
      v-model="location_item_component_name"></ion-input>
    <ion-button slot="end" color="primary" size="small" fill="clear">
      <ion-icon slot="icon-only" :icon="createOutline"></ion-icon>
    </ion-button>
  </ion-item>
</template>

<script>
import { modalController, IonContent } from '@ionic/vue';
import { close, add } from 'ionicons/icons';
import { arrayToTree } from "performant-array-to-tree";
import { db } from "@/services/db";
import { createOutline } from "ionicons/icons";
import NoData from "@/components/NoData.vue";
import { v4 as uuidv4 } from "uuid";
import AddNewOrExistingComponentModal from "@/components/AddNewOrExistingComponentModal.vue";

export default {
  name: "SelectOrCreateModal",
  props: ['location_item_uuid', 'disabled', 'value', 'only_parents'],
  components: {
    IonContent,
    NoData,
  },
  data() {
    return {
      createOutline,
      close,
      add,
      isOpen: false,
      location_item_components: [],
      location_item_component: { name: "-" },
      current_selected: null,
      location_item_name: null,
      location_item_component_name: null,
      original_location_item_component_name: null,
      components: [],
      is_parent: true,
      sub_location_item_component_name: null,
      loading: false,
    }
  },
  emits: ['refresh', 'open'],
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      this.location_item_components = await db.location_item_components.toArray();

      if (this.value) {
        this.location_item_component = this.location_item_components.find(item => item.uuid === this.value);

        if (this.location_item_component) {
          // this.location_item_component_name = this.location_item_component.name;
          // this.original_location_item_component_name = this.location_item_component.name;
          // if parent_uuid is null, then it is a parent
          if (this.location_item_component.parent_uuid === null) {
            this.location_item_component_name = this.location_item_component.name;
            this.original_location_item_component_name = this.location_item_component.name;
          } else {
            // if parent_uuid is not null, then it is a sub
            const parent = this.location_item_components.find(item => item.uuid === this.location_item_component.parent_uuid);
            if (parent) {
              this.location_item_component_name = parent.name + " -> " + this.location_item_component.name;
              this.original_location_item_component_name = parent.name + " -> " + this.location_item_component.name;
            } else {
              // Parent not found, use component name only
              this.location_item_component_name = this.location_item_component.name;
              this.original_location_item_component_name = this.location_item_component.name;
            }
          }
        }
      }
    },
    async saveLocation() {
      if (this.location_item_component_name === this.original_location_item_component_name) {
        return;
      }

      let url = "/inspections/" + this.$store.getters.getInspectionId + "/bulk-location-item-components";

      this.location_item_component.name = this.location_item_component_name;
      const copy_location_item_component = { ...this.location_item_component };

      await this.$requests.post("location_item_components", url, {
        location_item_components: [copy_location_item_component],
      });

      this.original_location_item_component_name = this.location_item_component_name;
    },
    open(item) {
      this.location_item_component = item;
      this.current_selected = item.uuid;
    },
    cancel() {
      modalController.dismiss(null, 'cancel');
    },
    async openSelectModal() {
      if (this.location_item_uuid) {
        const location_item = await db.location_items.where('uuid').equals(this.location_item_uuid).first();
        this.location_item_name = location_item.name;
      }

      const modal = await modalController.create({
        component: AddNewOrExistingComponentModal,
        componentProps: {
          location_item_uuid: this.location_item_uuid,
          location_item_name: this.location_item_name,
          only_parents: this.only_parents,
        },
        breakpoints: [0, 1],
        initialBreakpoint: 1,
      });

      // present the modal
      await modal.present();

      // listen for close event
      const { data, role } = await modal.onWillDismiss();

      if (data) {
        this.location_item_component = {
          uuid: data.sub_uuid,
          name: data.sub_name,
          parent_uuid: data.parent_uuid,
          parent_name: data.parent_name,
        };

        // if we have sub: parent_name -> sub_name
        if (data.sub_name) {
          this.location_item_component_name = data.parent_name + " -> " + data.sub_name;
          this.current_selected = data.sub_uuid;
          this.location_item_component = await db.location_item_components.where('uuid').equals(data.sub_uuid).first();
        } else {
          this.location_item_component_name = data.parent_name;
          this.current_selected = data.parent_uuid;
          this.location_item_component = await db.location_item_components.where('uuid').equals(data.parent_uuid).first();
        }
      }
    },
    onWillDismiss() {
      this.isOpen = false;
    },
  },
  computed: {
    getLocationItemComponents() {
      if (this.location_item_components) {
        return this.location_item_components.filter(item => item.location_item_uuid === this.location_item_uuid);
      }
      return [];
    },
    toTree() {
      if (this.getLocationItemComponents && this.getLocationItemComponents.length > 0) {
        return arrayToTree(this.getLocationItemComponents, { id: "uuid", parentId: "parent_uuid", childrenField: "children", dataField: null });
      }
      return [];
    },
  },
  watch: {
    value: {
      handler() {
        this.current_selected = this.value;
        if (this.value) {
          this.location_item_component = this.getLocationItemComponents.find(item => item.uuid === this.value);
          if (this.location_item_component) {
            this.location_item_component_name = this.location_item_component.name;
          }
        }
      },
      immediate: true,
      deep: true
    },
    current_selected: {
      handler(newValue) {
        this.$emit('change', newValue);
        this.$emit('update:value', newValue);
        this.isOpen = false;
      }
    }
  }
}
</script>

<style scoped>
.list-md {
  padding: 0px !important;
}
</style>